import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { WordMark } from "@/components/brand";
import { Loader2 } from "lucide-react";

export default function GoogleCallback() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState("");

  useEffect(() => {
    const code = params.get("code");
    if (!code) { setError("No authorization code returned from Google."); return; }
    api.post("/auth/google/callback", { code })
      .then(({ data }) => { localStorage.setItem("thed_token", data.token); setUser(data.user); nav(data.user.is_staff ? "/admin" : "/portal"); })
      .catch((e) => setError(apiErr(e)));
  }, [params, nav, setUser]);

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center p-6 text-center">
      <div>
        <Link to="/"><WordMark size="text-4xl" /></Link>
        {error ? (
          <div className="mt-8 max-w-sm">
            <p className="text-red-300 text-sm">{error}</p>
            <Link to="/login" className="text-gold text-sm mt-4 inline-block">Back to sign in</Link>
          </div>
        ) : (
          <div className="mt-8 flex items-center justify-center gap-3 text-muted-foreground"><Loader2 className="animate-spin" size={18} /> Signing you in…</div>
        )}
      </div>
    </div>
  );
}
